import { WAITING_LIST_ACTION } from "./types";

export const requireWaitingList = required => {
  return {
    type: WAITING_LIST_ACTION.REQUIRE_WAITING_LIST,
    payload: { required }
  };
};

export const selectPreferredTime = (time = "") => {
  return {
    type: WAITING_LIST_ACTION.UPDATE_PREFERRED_TIME,
    payload: { time }
  };
};



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/actions/waitingListActions.js